<template>
    <ns-loader
        ref="ns-loader"
        class="ns-loader"
        :to-load="toLoad"
        @dataFetched="onDataFetched"
    >
        <div slot="content">
            <div
                v-if="hasImportableMotors"
                class="import-motor"
            >
                <h4>{{ getText('audit_sites_select') }}</h4>
                <div
                    v-for="(site, index) in importableMotorsSets.site_name"
                    :key="index"
                >
                    <el-card
                        class="import-motor__card"
                    >
                        <div
                            class="import-motor__card__container"
                            @click="selectedSiteName(site)"
                        >
                            <div>
                                <span>{{ site }}</span>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
            <div v-else>
                {{ getText('audit_sites_no_importable_motor') }}
            </div>
        </div>
    </ns-loader>
</template>

<script>
import { mapGetters } from 'vuex';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
export default {

    name: 'SitesModal',

    components: {
        NsLoader
    },

    data () {
        return {
            importableMotorsSets: []
        };
    },

    computed:{
        ...mapGetters([
            'currentUser',
            'getText'
        ]),
        toLoad() {
            return [
                {
                    name: 'importableMotorsSets',
                    model: 'importableMotors',
                    sets: true,
                    filters: {
                        user_uid: this.currentUser.uid,
                        archived: false,
                    }
                }
            ];
        },
        hasImportableMotors(){
            return Object.keys(this.importableMotorsSets).length > 0;
        }
    },
    methods:{
        onDataFetched(res){
            this.$set(this, 'importableMotorsSets', res.importableMotorsSets);
        },
        selectedSiteName(siteName){
            this.$emit('selectedSite', siteName);
        }
    }
};
</script>

<style lang="scss">
.ns-vue-loader.ns-loader{
    .import-motor{
        max-height: 400px;
        overflow-y: auto;
        .el-card.import-motor__card{
            max-height: 60px;
            min-height: 60px;
            margin-top: 1rem;
            cursor: pointer;
            height: 60px;
            .el-card__body{
                max-height: 60px;
                height: 60px;
                text-align: left !important;
            }
        }
    }
}
.el-card.import-motor__card.is-always-shadow {
    max-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/import-motor-modal/sitesModal.vue